import { Component } from "react";
import { Link } from "react-router-dom";
import "./Footerhome.css";
import { useLanguage } from "../../contexts/LanguageContext";
import { useTranslation } from "../../hooks/useTranslation";

class FooterhomeComponent extends Component {
  constructor() {
    super();
    this.state = {
      usersData: localStorage.getItem("user_data")
        ? JSON.parse(localStorage.getItem("user_data"))
        : {},
    };
  }

  render() {
    const { currentLanguage, t } = this.props;
    const path = (path) => this.props.getPathWithLanguage ? this.props.getPathWithLanguage(path, currentLanguage) : path;
    
    return (
      <div className="homepage_footer_container">
        <div className="homepage_footer_list">
          <h2 className="homepage_footer_title">{t ? t('footer.buying') : 'Kupujete?'}</h2>
          {this.state.usersData.id ? (
            ""
          ) : (
            <Link to={path("/registracija")}>
              <div className="homepage_footer_text">{t ? t('footer.registration') : 'Registracija'}</div>
            </Link>
          )}
          <Link to={path("/svekategorije")}>
            <div className="homepage_footer_text">{t ? t('footer.shopping') : 'Kupovina'}</div>
          </Link>
          <Link to={path("/uslovikoristenja")}>
            <div className="homepage_footer_text">{t ? t('footer.rulesTerms') : 'Pravila i uslovi'}</div>
          </Link>
        </div>
        <div className="homepage_footer_list">
          <h2 className="homepage_footer_title">{t ? t('footer.selling') : 'Prodajte'}</h2>
          {this.state.usersData.id ? (
            <Link to={path("/novaprodaja")}>
              <div className="homepage_footer_text">{t ? t('footer.newSale') : 'Nova prodaja'}</div>
            </Link>
          ) : (
            <Link to={path("/registracija")}>
              <div className="homepage_footer_text">{t ? t('footer.registration') : 'Registracija'}</div>
            </Link>
          )}
          <Link to={path("/uslovikoristenja")}>
            <div className="homepage_footer_text">{t ? t('footer.rulesTerms') : 'Pravila i uslovi'}</div>
          </Link>
          <Link to={path("/placanje")}>
            <div className="homepage_footer_text">{t ? t('footer.benefitsPricing') : 'Pogodnosti i cijena'}</div>
          </Link>
        </div>
        <div className="homepage_footer_list">
          <h2 className="homepage_footer_title">{t ? t('footer.socialMedia') : 'Društvene mreže'}</h2>
          <a
            href="https://www.facebook.com/online.prodaja.kupovina/"
            target="_blank"
            rel="noreferrer"
          >
            <div className="homepage_footer_text homepage_footer_img">
              {t ? t('footer.facebook') : 'Facebook'}
            </div>
          </a>
        </div>
        <div className="homepage_footer_list">
          <h2 className="homepage_footer_title">{t ? t('footer.aboutUs') : 'O nama'}</h2>
          <Link to={path("/kontakt")}>
            <div className="homepage_footer_text">{t ? t('footer.contact') : 'Kontakt'}</div>
          </Link>
        </div>
        <div className="homepage_footer_copyright">
          {t ? t('footer.copyright') : 'Copyright © 2026 OPK.ba. Sva prava zadržana.'}
        </div>
      </div>
    );
  }
}

// Wrapper component with hooks
export const Footerhome = (props) => {
  const { currentLanguage, getPathWithLanguage } = useLanguage();
  const { t } = useTranslation();

  return (
    <FooterhomeComponent 
      {...props} 
      currentLanguage={currentLanguage}
      getPathWithLanguage={getPathWithLanguage}
      t={t}
    />
  );
};
